import React from 'react';
import PropTypes from 'prop-types';

import {
  GridItem,
  GridContainer,
} from '../../generic';

import {
  DeviceEditCard,
} from '../components';

const DeviceDetailTab = (props) => {
  const { device, canEdit } = props;
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <DeviceEditCard
          device={device}
          canEdit={canEdit}
        />
      </GridItem>
    </GridContainer>
  );
};

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  device: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

DeviceDetailTab.propTypes = propTypes;
export default DeviceDetailTab;
